import dayjs from 'dayjs';
import isLeapYear from 'dayjs/plugin/isLeapYear';
import Day from './day';
import Month from './month';
dayjs.extend(isLeapYear);
export default class Calendar {
    constructor(year = null, monthNumber = null, lang = 'default') {
        this.weekDays = Array.from({ length: 7 });
        this.today = new Day(null, lang);
        this.year = year !== null && year !== void 0 ? year : this.today.year;
        this.month = new Month(new Date(this.year, (monthNumber || this.today.monthNumber) - 1), lang);
        this.lang = lang;
        this.weekDays.forEach((item, index) => {
            const day = this.month.getDay(index);
            this.weekDays[day.dayNumber - 1] = day.day;
        });
    }
    getMonth(monthNumber) {
        return new Month(new Date(this.year, monthNumber - 1), this.lang);
    }
    getPreviousMonth() {
        const month = 11;
        if (this.month.number === 1) {
            return new Month(new Date(this.year - 1, month), this.lang);
        }
        return new Month(new Date(this.year, this.month.number - 2), this.lang);
    }
    getNextMonth() {
        if (this.month.number === 1) {
            return new Month(new Date(this.year + 1, 0), this.lang);
        }
        return new Month(new Date(this.year, this.month.number + 2), this.lang);
    }
    goToDate(monthNumber, year) {
        this.month = new Month(new Date(year, monthNumber - 1), this.lang);
        this.year = year;
    }
    goToNextYear() {
        this.year += 1;
        this.month = new Month(new Date(this.year, 0), this.lang);
    }
    goToPreviousYear() {
        const month = 11;
        this.year -= 1;
        this.month = new Month(new Date(this.year, month), this.lang);
    }
    goToNextMonth() {
        const month = 12;
        if (this.month.number === month) {
            return this.goToNextYear();
        }
        this.month = new Month(new Date(this.year, this.month.number + 1 - 1), this.lang);
    }
    goToPreviousMonth() {
        if (this.month.number === 1) {
            return this.goToPreviousYear();
        }
        this.month = new Month(new Date(this.year, this.month.number - 1 - 1), this.lang);
    }
}
